import {
  AfterContentInit, AfterViewInit, Component, OnDestroy, OnInit, ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ITreatyState} from '../../store/reducers/treaty.reducer';
import {select, Store} from '@ngrx/store';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Configuration} from '@shared/models/configuration';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Subject, timer} from 'rxjs';
import {debounce, takeUntil} from 'rxjs/operators';
import {FileInfo} from '../../models/treaty.models';
import {TreatyApiService} from '../../services/treaty.service';
import {VirtualGridComponent} from '@shared/components/virtual-grid/virtual-grid.component';
import {process, State} from '@progress/kendo-data-query';
import {FormBuilder, FormGroup} from '@angular/forms';
import {GetOtherDocumentInfoAction} from '../../store/actions/treaty.actions';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {
  SetActivityFeedAction,
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction
} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {PlatformSidebarService} from "@shared/components/platform-sidebar/store/platform-sidebar.service";
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';


@Component({
    standalone: false,
    selector: 'particle-treaty-requested-jurisdiction',
  templateUrl: './treaty-requested-jurisdiction.component.html',
  styleUrls: ['./treaty-requested-jurisdiction.component.scss']
})


export class TreatyRequestedJurisdictionComponent implements OnInit, OnDestroy {
  appUrl = '';
  @ViewChild(VirtualGridComponent, {static: true}) gridRef: VirtualGridComponent;
  currentMenu: string;
  ngUnsubscribe$ = new Subject<void>();
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  documentType: string;
  otherVersionsContentViewEnable: boolean;
  otherVersions: FileInfo[];
  inputForm: any;

  private config: any;

  constructor(private store: Store<ParticleState>,
              private treatyStore: Store<ITreatyState>,
              protected activatedRoute: ActivatedRoute,
              private queryState: Store<IQueryState>,
              private router: Router,
              private treatyService: TreatyApiService, private formBuilder: FormBuilder,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private platformSidebarService: PlatformSidebarService,
              private sidebarService: FuseSidebarService) {
    this.breadcrumbKey = 'BreadcrumbByTreatyId';
    this.sourceKey = 'Treaty-Requested-Jurisdiction';
    this.invalidateSubject = new InvalidateSubject();
    this.inputForm = this.formBuilder.group({
      value: ['']
    });
  }

  ngOnInit() {
    this.store.pipe(select(getApplicationWithId, 'ITCE')).subscribe(app => {
      if (app && app.HostUrl) {
        this.appUrl = app.HostUrl;
      }
    });
    this.inputForm.valueChanges.pipe(debounce(() => timer(500))).subscribe(data => {
      const state: State = {
        // Initial filter descriptor
        filter: {
          logic: 'and',
          filters: [{field: 'cells.Name.displayText', operator: 'contains', value: data.value}]
        }
      };

      this.gridRef.gridView = this.filter(this.gridRef.view, state, data.value);
      console.log('Show the view:::', this.gridRef.gridView);
    });
    this.otherVersionsContentViewEnable = false;
    this.activatedRoute.params.subscribe((params: any) => {
      const id = 'treaties';

      this.breadcrumbs$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.queryState, this.breadcrumbKey, {'[ID]': `${id}`, '[DOCUMENT_ID]': ''});
      const config = Configuration.getSmartGridConfig(this.sourceKey);
      config.Parameters['PARENT_ID'] = id;
      // this.invalidateSubject.invalidate(id);
    });
    const activityInfo = {type: 'Tool', 'id': 'itrce-treaties', 'title': 'Treaty', isDefault: true};
    this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  private filter(view: any, state: State, search: string) {
    search = search.toLowerCase();
    const data = view.filter(data => data.cells.RequestedJurisdiction.displayText.toLowerCase().includes(search));
    return {
      data: data,
      total: data.length
    };
  }

  onGridCellValueChange($event) {
    const id = $event.cells['RequestedJurisdiction'].value;
    const type = $event.cells['Type'].value;
    const countryCode = $event.cells['CountryCode'].value;
    const documentId = $event.cells['DocumentId'].value;

    this.router.navigate([countryCode.toLowerCase()], {relativeTo: this.activatedRoute});

  }

  showPdf(file: any) {

  }

  otherVersionDisplay() {

  }


  ngOnDestroy(): void {
    this.sidebarService.getSidebar('rightsidebar').close();
    this.sidebarService.getSidebar('rightsidebar').fold();
    this.platformSidebarService.hideSidebarIcon("Related Law Changes");
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
